module.exports = __webpack_public_path__ + "static/media/badkamer_2.c569b064.jpg";